import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { FrsReleaseService } from '../services/frs.release.service';
import { PackageModelService } from '../services/frs.package.model.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackerFilterService } from '../../tracker/services/tracker.filter.service';
import { FrsReleaseHelper } from '../services/frs.release.helper.service';
import { TourService } from '../../../core/modules/tour/tour.service';

import * as _ from 'lodash';
import { UserService } from '../../../core/services/core.user.service';
import { FrsReleaseEditComponent } from '../frsReleaseEdit/frs.release.edit.component';

@Component({
    selector: 'gf-footer',
    template: require('./frs.release.details.html')
})
export class FrsReleaseDetailsComponent implements OnInit {

    @Input() frspackage: any = null;
    @Input() project: any = null;
    @Input() projectMenu: any = null;

    protected canContribute = false;
    protected breadcrumbs = [];
    protected release: any = false;
    protected trackerItems: any = null;

    protected dataTab = 'releasenotes';
    protected remainingChartOptions: any = null;
    protected remainingChartData: any = null;
    protected tibOptions: any = null;
    protected trackerOptions: any = null;

    protected burndown: any = false;
    protected burndownChartOptions: any = null;
    protected burndownChartData: any = null;

    constructor(
        private stateService: StateService, 
        private frsReleaseService: FrsReleaseService,
        private packageModel: PackageModelService,
        private modalService: NgbModal,
        private trackerFilterService: TrackerFilterService,
        private frsReleaseHelper: FrsReleaseHelper,
        private userService: UserService,
        private tourService: TourService,
    ) { }

    ngOnInit() {
        this.canContribute = _.get(this.projectMenu, 'tracker', 0) > 0;

        this.packageModel.setAcl(
            this.userService.session.getUnixName(),
            _.get(this.stateService.params, 'unixName', '')
        );
        this.refreshAll();
    };

    fetch() {
        this.release = false;

        this.frsReleaseService.fetchDetails(this.stateService.params.releaseId, { rel: 'trove,tisummary,remaining,files' })
            .then((response) => {
                this.release = response;
                if (_.get(this.release, 'isReleased', '') != 'Y') {
                    this.tourService.setTour('releaseDetailsCtrl');
                }

                if (_.get(response, 'rel.files.length', 0) > 0) {
                    this.dataTab = 'files';
                } else if (_.get(response, 'changes', '') != '') {
                    this.dataTab = 'changelog';
                } else {
                    this.dataTab = 'releasenotes';
                }

                this.remainingChartOptions = this.frsReleaseHelper.charts.getRemainingChartOptions();
                this.remainingChartData = this.frsReleaseHelper.charts.getRemainingChartData(this.release);

                this.tibOptions = this.frsReleaseHelper.trackerItems.getTIBOptions(response);
                this.trackerOptions = this.frsReleaseHelper.trackerItems.getTrackerOptions();

                this.breadcrumbs = this.frsReleaseHelper.display.breadcrumbsFor(this.project, this.release);
                this.frsReleaseHelper.display.setWindowTitle(this.project, this.release);

                var burndownParams = { releaseId: this.stateService.params.releaseId, end_date: null };
                if (this.release.isReleased == 'Y') {
                    //For closed releases, we indicate the end date to get the proper burndown data
                    burndownParams.end_date = this.release.releaseDate;
                }

                this.frsReleaseService.getBurndown(this.stateService.params.releaseId, burndownParams)
                    .then((response: any) => {
                        this.burndown = response.items;
                        this.burndownChartOptions = this.frsReleaseHelper.charts.getBurndownChartOptions(this.burndown);
                        this.burndownChartData = this.frsReleaseHelper.charts.getBurndownChartData(this.burndown);
                    });
            }, function (response) {
                console.log(response);
                this.stateService.go('^', { reload: true });
            });
    };

    trackerItemFetch() {
        this.trackerItems = false;

        var params = this.frsReleaseHelper.trackerItems.getFetchParams(this.project);

        this.trackerFilterService.performSearch(params)
            .then((data) => {
                this.trackerItems = { items: data };
            })
            .catch((response) => {
                console.log(response);
                this.trackerItems = { items: [] };
            });
    };

    showEditRelease = (release) => {
        const modalRef = this.modalService.open(FrsReleaseEditComponent);
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.release = release;
        modalRef.componentInstance.close.subscribe(() => {
            modalRef.close();
        });
    };

    showEditReleaseIcon(release) {
        return this.packageModel.acl.isAdmin &&
            this.packageModel.acl.isAdmin(release.package);
    };

    refreshAll = () => {
        this.fetch();
        if (this.canContribute) {
            this.trackerItemFetch();
        }
    };

    switchTab(event: Event, tabName: string) {
        event.preventDefault();
        this.dataTab = tabName;
    }
};
